// extracted by mini-css-extract-plugin
module.exports = {"AnimatedDropDown":"AnimatedDropDown_AnimatedDropDown__1SxMO","isOpen":"AnimatedDropDown_isOpen__3I5S_"};